export const getEditionsCartQueryVariables = (ids: string[]) => ({
	filter: {
		product: {
			id: {
				_in: ids,
			},
		},
	},
	dropConfigFilter: {
		products: {
			id: {
				_in: ids,
			},
		},
	},
});
